import { deserialize, serializable } from 'serializr';
import { PageObject } from '@testsigma/organism';
import { Base } from '@models/base.model';

export class SalesforceApplication extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public Label: string;
  @serializable
  public description: string;
  @serializable
  public externalId: string;
  @serializable
  public applicationVersionId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceApplication, input));
  }
}
